/**
 * =============================================================================
 * IDS CRM Web - Customer status chip (Prospect / Active / Dormant)
 * =============================================================================
 *
 * One chip for a customer's, distributor's or site's status, labelled from the
 * shared vocabulary in utils/customerStatus.js.
 *
 *   <CustomerStatusChip status="dormant" />
 *
 * Its own customer-status-chip class family rather than .status-chip, whose
 * colours are defined unscoped by more than one page stylesheet — see
 * CustomerStatusChip.css.
 *
 * =============================================================================
 */

import React from 'react';
import { customerStatusLabel } from '../utils/customerStatus';
import './CustomerStatusChip.css';

function CustomerStatusChip({ status }) {
  const slug = String(status || 'unknown').toLowerCase().replace(/[^a-z0-9]+/g, '-');
  return (
    <span className={`customer-status-chip is-${slug}`}>
      {customerStatusLabel(status)}
    </span>
  );
}

export default CustomerStatusChip;
